import { render, staticRenderFns } from "./ColHead.vue?vue&type=template&id=70372d69&lang=pug&"
import script from "./ColHead.vue?vue&type=script&lang=js&"
export * from "./ColHead.vue?vue&type=script&lang=js&"
import style0 from "./ColHead.vue?vue&type=style&index=0&id=70372d69&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70372d69')) {
      api.createRecord('70372d69', component.options)
    } else {
      api.reload('70372d69', component.options)
    }
    module.hot.accept("./ColHead.vue?vue&type=template&id=70372d69&lang=pug&", function () {
      api.rerender('70372d69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/table/ColHead.vue"
export default component.exports